import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faNewspaper,
} 
from '@fortawesome/free-solid-svg-icons'
import { LanguageContext } from '../Language/LanguageContext'
import dayjs from 'dayjs'

export default function LatestNewsSection(props){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.home
    const isLoading = props.isLoading || false
    const newsList = props.news || []
    
    const convertDate = (date) =>{
        let toDate = new Date(date)
        let formattedDate = dayjs(toDate).format("D MMMM YYYY H:mm")
        return formattedDate
    }

    const NewsItem = (props) =>{
        return(
            <Link to={props.to} className="news-item">
                <div className="icon">
                    <FontAwesomeIcon icon={faNewspaper}/>
                </div>
                <div className="detail">
                    <div>{props.title}</div>
                    <div className="date">{props.date}</div>
                </div>
            </Link>
        )
    }

    return(
        <div className="section">
            { isLoading ?
            <div className="loading-section">
                <Spinner 
                variant="primary" 
                animation="border"
                size="sm"
                />
            </div> : null
            }
            <div className="section-title">{lang.latest_news}</div>
            <div className="news-container">
                { newsList.map((item, key)=>
                <NewsItem 
                key={key}
                to={"/news/view/"+item.id}
                title={item.title}
                date={convertDate(item.createdDate)}
                />
                )}
            </div>
            <div style={{marginTop: 20, textAlign: 'center'}}>
                <Link to="/news" className="link-section">
                    {lang.see_more_news}
                </Link>
            </div>
        </div>
    )
}
